import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import PropTypes from 'prop-types';
import SocialMedia from '../social-media/socialmedia';

//style
import { FooterContainer } from './footer.css';
import { Row, Col } from 'react-awesome-styled-grid';

const Footer = ({ data, selectedLanguage, footerMenu }) => {
  const line = '|';
  const footerItem = data.pageMetadataJson.pages
    .filter(page => {
      return (
        page.pageLang === selectedLanguage && footerMenu.includes(page.url)
      );
    })
    .sort((a, b) => {
      return footerMenu.indexOf(a.url) - footerMenu.indexOf(b.url);
    });
  return (
    <FooterContainer>
      <Row style={{ margin: 0 }}>
        <Col xs={12}>
          <SocialMedia />
        </Col>
        <Col className={'menu-links'} xs={12}>
          {footerItem.map((page, index) => (
            <div key={page.url + page.menuTitle}>
              <a href={page.url} target="_blank" rel="noopener noreferrer">
                {page.menuTitle}
              </a>
              {index < footerItem.length - 1 ? line : null}
            </div>
          ))}
        </Col>
        <Col className={'aut-copy'} xs={12}>
          <a
            className={'trial-page'}
            href="https://www.trialscope.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            {data.footerJson.author}
          </a>
        </Col>
        <Col className={'aut-copy-last'} xs={12}>
          <p>{data.footerJson.copyRight}</p>
        </Col>
      </Row>
    </FooterContainer>
  );
};

const FooterWithQuery = props => (
  <StaticQuery
    query={graphql`
      query {
        site {
          siteMetadata {
            siteTitle
            mainMenu
            languages {
              defaultLangKey
              langs
              defaultPageUrl
            }
          }
        }
        pageMetadataJson {
          pages {
            menuTitle
            url
            pageLang
          }
        }
        footerJson {
          author
          copyRight
        }
      }
    `}
    render={data => <Footer data={data} {...props} />}
  />
);

export default FooterWithQuery;

Footer.propTypes = {
  data: PropTypes.any.isRequired,
  title: PropTypes.string.isRequired,
  selectedLanguage: PropTypes.any.isRequired,
  footerMenu: PropTypes.array.isRequired,
};
